import React, { Component } from "react";
import { Row, Col, Input, DatePicker } from "antd";
import { withRouter } from "react-router-dom";
import InvitationToPDF from "../InvitationToPDF/InvitationToPDF";
import PrintComponent from "../../../Components/PrintComponent/PrintComponent";
const { TextArea } = Input;
const dateFormat = "YYYY.MM.DD HH:mm";
var moment = require("moment");
class CreateInvitation extends Component {
  state = {
    invitationNumber: this.props.invitationNumber,
    tenderAcceptEndDate: this.props.tenderAcceptEndDate,
    tenderOpenDate: this.props.tenderOpenDate,
    showNewInputForm: false,
  };
  render() {
    return (
      <div className="Container">
        <Row style={{ height: 56 }} justify="start" align="middle">
          <Col>
            <div className="HeaderLabel">4. Урилга</div>
          </Col>
        </Row>
        <Row justify="end" align="middle">
          <Col style={{ marginTop: -70 }}>
            <PrintComponent
              buttonText="Урилга татах"
              content={<InvitationToPDF />}
            />
          </Col>
        </Row>
        <div style={{ marginTop: 20, paddingRight: 100 }}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <div className="Label" style={{ marginBottom: 5 }}>
                Урилгийн дугаар
              </div>
              <Input size="middle" disabled />
            </Col>
            <Col span={8}>
              <div className="Label" style={{ marginBottom: 5 }}>
                Тендер хүлээн авах эцсийн хугацаа
              </div>
              <DatePicker
                //value={moment(this.state.tenderAcceptEndDate, dateFormat)}
                onChange={this.onChangeEndDate}
                format={dateFormat}
                size="middle"
                style={{ width: "100%" }}
                placeholder=""
                showTime={true}
              ></DatePicker>
            </Col>
            <Col span={8}>
              <div className="Label" style={{ marginBottom: 5 }}>
                Тендер нээх хугацаа
              </div>
              <DatePicker
                //value={moment(this.state.tenderOpenDate, dateFormat)}
                onChange={this.onChangeOpenDate}
                size="middle"
                format={dateFormat}
                style={{ width: "100%" }}
                placeholder=""
                showTime={true}
              ></DatePicker>
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }} gutter={(16, 16)}>
            <Col span={24}>
              <div className="Label" style={{ marginBottom: 5 }}>
                Дэлгэрэнгүй тайлбар
              </div>
              <TextArea rows={6} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(CreateInvitation);
